var _style, _path, _polygon, _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVozandes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 244.59 127.39",
    style: {
      enableBackground: "new 0 0 244.59 127.39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#862448;stroke:#862448;stroke-miterlimit:10;}\n\t.st1{font-family:'HighTowerText-Reg';}\n\t.st2{font-size:15.7px;}\n\t.st3{font-family:'Verdana';}\n\t.st4{font-size:8px;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.18,49.25c-1.65-12.38-25.35-11.77-25.35-11.77l4.75-11.15L113.36,60.6l6.19-21.47l-15.69,8.26l-1.86,5.99 H87.97l4.95-18.16l-11.97,5.57L68.36,83.72l12.59-6.19l4.54-14.04h13.83l-8.26,31.79l29.7-26.83c17.36,17.75,32.63,7.43,32.63,7.43 l3.72,4.75l9.49-6.61l-3.3-3.88C163.31,70.13,174.83,61.63,173.18,49.25z M159.39,61.84l-2.27-3.92l-13.42,7.02l2.68,5.2 c-16.1-1.82-14.24-11.6-7.64-17.38c6.61-5.78,14.04-6.19,20.64-2.06C165.99,54.82,159.39,61.84,159.39,61.84z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "106.34,41.61 119.76,35.42 124.3,18.7 132.76,18.7 137.51,9.2 128.01,9.2 130.08,3.01 118.11,3.01  116.45,9 106.34,9 102.01,18.28 113.77,18.28 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1.7531 110.7197)",
    className: "st1 st2"
  }, "HOSPITAL VOZANDES QUITO"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 26.9298 122.7647)",
    className: "st3 st4"
  }, "\u201CA la gloria de Dios y al Servicio del Ecuador\u201D")), /*#__PURE__*/React.createElement("rect", {
    x: 82.17,
    y: 141,
    style: {
      fill: "none"
    },
    width: 1.57,
    height: 24.6
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVozandes);
export default __webpack_public_path__ + "static/media/vozandes.1d9c7689d21bf1633e903844f55aea58.svg";
export { ForwardRef as ReactComponent };